import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ILocation } from '@web-nx-ng-tsc/web-shared-data-access';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
import { ROUTER_TOKENS } from '../../../../../../../apps/promo-web/web-toyo/src/app/app.routes';
import { RouterLink } from '@angular/router';
import { ReplaceBucket } from '@web-nx-ng-tsc/util-func';

@Component({
  selector: 'lib-web-shared-ui-location-card',
  imports: [MatIconModule, RouterLink],
  templateUrl: './lib-location-card.component.html',
  styleUrl: './lib-location-card.component.scss',
})
export class LibLocationCardComponent {
  @Input() set data(value: ILocation) {
    this.loggingService.log('data in CardComp :', value);

    this.dataSignal.set(value);
  }
  @Input() isMock = false;

  @Output() emitLocationBranch = new EventEmitter();

  private readonly loggingService = inject(LoggingService);
  public readonly replaceBucket = new ReplaceBucket();

  dataSignal = signal<ILocation>({
    id: '',
    img: '',
    title: '',
    address: '',
    phone: '',
    email: '',
    etax: false,
    lat: '',
    lng: '',
  });

  onClickLocationBranch(lat: string, lng: string) {
    const location = {
      location_lat: lat,
      location_lng: lng,
    };
    this.emitLocationBranch.emit(location);
  }

  protected readonly ROUTER_TOKENS = ROUTER_TOKENS;
}
